import { Navigate, useParams } from "react-router-dom";

export const CrmCustomersListRedirect = () => (
    <Navigate to="/crm/customers" replace />
);

export const CrmCustomerDetailRedirect = () => {
    const { id } = useParams();
    return <Navigate to={`/crm/customers/customer/${id}`} replace />;
};

export const CrmCustomerSubscriptionRedirect = () => {
    const { id } = useParams();
    return <Navigate to={`/crm/customers/customer/subscription/${id}`} replace />;
};
